import React from "react";

import styles from "components/BudgetBuilder/Overview/OverviewLineItemsList/styles.css";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { getPeriodSubtotal } from "utils/budgetBuilder";


const OverviewInternalCostShareMemberRow = ({ items, index }) => {
	const { currencyFormatter } = useTenantFormatter();

	return (
		<Table.Row>
			<Table.Cell className={styles.cellAlignLeft}>
				<span>{`Research Team - ${(items[0]?.name || "Unnamed Member")}`}</span>
			</Table.Cell>
			{items
				.map(member => member?.costShare)
				.map((item, p) => (
					<Table.Cell key={`period-${index}-${p}`} className={styles.cellAlignRight}>
						{currencyFormatter(item?.reqSalary + item?.fringeRequested)}
					</Table.Cell>
				))}
			<Table.Cell className={styles.cellAlignRight}>
				<span className={styles.bold}>
					{currencyFormatter(getPeriodSubtotal(items, true))}
				</span>
			</Table.Cell>
		</Table.Row>
	);
};

export default OverviewInternalCostShareMemberRow;
